document.addEventListener('DOMContentLoaded', function () {
  const enableVideoMemory = true;

  const video = document.getElementById('info-video');
  const hinweis = document.getElementById('video-hinweis');
  const checkboxArea = document.getElementById('checkbox-area');
  const checkbox1 = document.getElementById('checkbox1');
  const checkbox2 = document.getElementById('checkbox2');
  const cartHinweis = document.getElementById('cart-hinweis');
  const freigabeHinweis = document.getElementById('freigabe-hinweis');
  const productKey = 'video_seen_biozid';

  let btn = document.querySelector('.product-form__buttons button[type="submit"]');
  let lastButtonHtml = btn ? btn.outerHTML : null;
  let previousReadyState = false;

  const originalText = 'IN DEN WARENKORB LEGEN';
  const hasSeenVideo = enableVideoMemory && localStorage.getItem(productKey) === 'true';

  if (enableVideoMemory) {
    checkbox1.checked = localStorage.getItem('checkbox1_checked') === 'true';
    checkbox2.checked = localStorage.getItem('checkbox2_checked') === 'true';
  }

  function updateButtonState() {
    if (!btn) return;

    btn.innerText = originalText;
    btn.disabled = false;
    btn.style.opacity = 1;
    btn.style.cursor = 'pointer';

    const videoWatched = checkboxArea.style.display === 'block';
    const shouldEnable = checkbox1.checked && checkbox2.checked;
    const isReady = videoWatched && shouldEnable;

    // Hinweistext
    if (cartHinweis) {
      if (isReady) {
        cartHinweis.style.display = 'none';
      } else {
        cartHinweis.innerText = videoWatched
          ? cartHinweis.dataset.textCheckbox
          : cartHinweis.dataset.textVideo;
        cartHinweis.style.display = 'block';
      }
    }

    // Grüner Freigabehinweis
    if (freigabeHinweis) {
      freigabeHinweis.style.display = isReady ? 'block' : 'none';
    }

    // ✅ Visual Pulse-Feedback nur beim Übergang von "nicht bereit" → "bereit"
    if (isReady && !previousReadyState) {
      btn.classList.add('pulse-once');
      setTimeout(() => {
        btn.classList.remove('pulse-once');
      }, 700);
    }

    previousReadyState = isReady;
  }

  function bindButtonClickBehavior() {
    if (!btn || btn.dataset.listenerBound === 'true') return;

    btn.dataset.listenerBound = 'true';
    btn.addEventListener('click', function (e) {
      const videoWatched = checkboxArea.style.display === 'block';
      const shouldEnable = checkbox1.checked && checkbox2.checked;

      if (!(videoWatched && shouldEnable)) {
        e.preventDefault();

        const infoBox = document.querySelector('.product-warning');
        if (infoBox) {
          const offset = 20;
          const elementTop = infoBox.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({ top: elementTop - offset, behavior: 'smooth' });

          infoBox.classList.add('pulse-once');
          setTimeout(() => {
            infoBox.classList.remove('pulse-once');
          }, 1000);
        }

        if (cartHinweis) {
          cartHinweis.innerText = videoWatched
            ? cartHinweis.dataset.textCheckbox
            : cartHinweis.dataset.textVideo;
          cartHinweis.style.display = 'block';
        }

        if (freigabeHinweis) {
          freigabeHinweis.style.display = 'none';
        }

        return;
      }
    });
  }

  function bindCheckboxEvents() {
    checkbox1.addEventListener('change', () => {
      if (enableVideoMemory) localStorage.setItem('checkbox1_checked', checkbox1.checked);
      updateButtonState();
    });

    checkbox2.addEventListener('change', () => {
      if (enableVideoMemory) localStorage.setItem('checkbox2_checked', checkbox2.checked);
      updateButtonState();
    });
  }

  function initAfterVideo() {
    if (hinweis) hinweis.style.display = 'none';
    checkboxArea.style.display = 'block';
    updateButtonState();
    bindCheckboxEvents();
    bindButtonClickBehavior();

    checkboxArea.classList.add('checkbox-pulse');
    setTimeout(() => {
      checkboxArea.classList.remove('checkbox-pulse');
    }, 1500);
  }

  if (hasSeenVideo) {
    initAfterVideo();
  } else {
    updateButtonState();
    bindButtonClickBehavior();

    video.addEventListener('timeupdate', function () {
      if (video.currentTime > video.lastTime + 1) {
        video.currentTime = video.lastTime;
      }
      video.lastTime = video.currentTime;
    });

    video.addEventListener('ended', function () {
      if (enableVideoMemory) {
        localStorage.setItem(productKey, 'true');
      }
      initAfterVideo();
    });

    video.addEventListener('loadedmetadata', function () {
      video.currentTime = 0;
    });
  }

  const observerTarget = document.querySelector('.product-form__buttons');
  if (observerTarget) {
    const observer = new MutationObserver(() => {
      const newBtn = document.querySelector('.product-form__buttons button[type="submit"]');
      if (!newBtn || newBtn.outerHTML === lastButtonHtml) return;

      lastButtonHtml = newBtn.outerHTML;
      btn = newBtn;

      updateButtonState();
      bindButtonClickBehavior();
    });

    observer.observe(observerTarget, { childList: true, subtree: true });
  }
});
